export default {
  title: '404',
  description:
    'Beklager, men siden du prøver å nå, eksisterer ikke eller er midlertidig utilgjengelig. Dette kan skyldes en feilstaving i nettadressen, en utdatert kobling eller at siden har blitt fjernet.',
  homelink: 'Prøv å gå tilbake til forsiden',
};
